import { Component, OnInit, AfterViewInit, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute, Params } from "@angular/router";
import { environment } from "../../../environments/environment";
import { AbstractSellerComponent } from "../abstract/seller.component";
import { DatePipe } from "@angular/common";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSort, Sort, MatSortHeader } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from "@angular/material/table";
import { ConfirmationDialog } from "../incs/confirmation-dialog.component";
import { Pair } from "../../obj/Pair";
import { EntityBase } from "../../entity/EntityBase";
import { BatchExport } from "../../entity/BatchExport";
import { AuthService } from "../../service/auth.service";
import { AnalyticsService } from "../../service/analytics.service";
import { GeneralService } from "../../service/general.service";
import { User } from "../../entity/User";
import { Company } from "../../entity/Company";
import { HeaderComponent } from "../incs/header.component";
import { MatIcon } from "@angular/material/icon";

@Component({
    selector: "kilowant-seller-batch-export-list",
    templateUrl: "../../../html/seller/seller-batch-export-list.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatSortHeader, MatIcon, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator, DatePipe]
})
export class SellerBatchExportListComponent extends AbstractSellerComponent implements OnInit, AfterViewInit {
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    displayedColumns: string[] = ["#","BatchId", "DateEntered","Action"];
    dataSource: MatTableDataSource<BatchExport> = new MatTableDataSource<BatchExport>([]);

    dialogRef: MatDialogRef<any> = null!;
    dropdownSettings:any = {};

    constructor(
        router: Router,
        route: ActivatedRoute,
        authService: AuthService,
        analyticsService: AnalyticsService,
        generalService: GeneralService,
        private datepipe: DatePipe,
        dialog: MatDialog
    ) { super(router, route, dialog, authService, analyticsService, generalService); }

    ngOnInit(): void {
         this.generalService.getBatchExportList()
             .then(cs => {
                 this.dataSource.data = cs;
             });
    }

    ngAfterViewInit(): void {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        this.dataSource.sortingDataAccessor = (item, property) => {
           switch (property) {
             case "BatchId": {
                 return item.id;
             }
             case "DateEntered": {
                 return this.datepipe.transform(item.dateEntered, "yyyyMMdd") || "";
             }
             default: {
                  return "";
             }
           }
        };
    }

    getBatchExportFile(batch: string): void {
       var a = document.createElement("a");
       document.body.appendChild(a);
       this.generalService.getBatchExport(batch)
       .subscribe((data:any) => {
          var blob = new Blob([data], {type: "octet/stream"});
          var url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = "kilowant.csv";
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
      });
    }

}